import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { BodySecondary, H4, SubtitleSecondary } from '../Base';
import Button from '../Button';
import Spacing from '../Spacing';

const SummarySection = styled.div`
  background-color: ${p => p.theme.colours.haze};
  margin-left: ${p => p.theme.spacing(-p.theme.grid.outerMargin)};
  margin-right: ${p => p.theme.spacing(-p.theme.grid.outerMargin)};
  padding: ${p => p.theme.spacing(2)} ${p => p.theme.spacing(2)}
    ${p => p.theme.spacing(5)};
  ${p =>
    p.disabled &&
    css`
      opacity: 0.25;
      pointer-events: none;
    `};
  ${p => p.theme.media.md`
    padding: ${p.theme.spacing(5)};
    margin: 0 auto;
  `};
`;

const Detail = styled.div`
  margin-bottom: ${p => p.theme.spacing(2)};
  ${p => p.theme.media.md`
    margin-bottom: ${p.theme.spacing(3)};
  `};
`;

const StyledBodySecondary = styled(BodySecondary)`
  color: ${p => p.theme.colours.grey_600};
`;

const StyledSummaryContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CartSummary = ({
  disableCartSummary,
  showCartSummary,
  payToday,
  monthlySubscription,
  monthlySubscriptionText,
  onContinueBtnClick,
  disableContinueBtn
}) => {
  return (
    <SummarySection disabled={disableCartSummary}>
      {showCartSummary && (
        <Detail data-testid="cart-summary">
          <Spacing bottom={0.5}>
            <StyledSummaryContent>
              <SubtitleSecondary>Upfront product cost</SubtitleSecondary>
              <H4 data-testid="upfront-cost">{payToday}</H4>
            </StyledSummaryContent>
          </Spacing>
          <Spacing bottom={1}>
            <StyledSummaryContent>
              <SubtitleSecondary>{monthlySubscriptionText}</SubtitleSecondary>
              <H4 data-testid="monthly-cost">{`${monthlySubscription}/mth`}</H4>
            </StyledSummaryContent>
          </Spacing>
          <Spacing bottom={2} bottomMd={3}>
            <StyledBodySecondary>
              Discounts will be calculated at checkout
            </StyledBodySecondary>
          </Spacing>
        </Detail>
      )}
      {onContinueBtnClick && (
        <Button
          block
          onClick={onContinueBtnClick}
          disabled={disableContinueBtn}
        >
          Next
        </Button>
      )}
    </SummarySection>
  );
};

CartSummary.propTypes = {
  /** Disables entire CartSummary */
  disableCartSummary: PropTypes.bool,
  /** Shows payToday and MonthSubscription */
  showCartSummary: PropTypes.bool,
  /** Upfront cost of the device */
  payToday: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Monthly charges of the plan */
  monthlySubscription: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  /** Sets the text to render for monthly subscription */
  monthlySubscriptionText: PropTypes.string,
  /** If this function is passed, continue button will be present*/
  onContinueBtnClick: PropTypes.func,
  /** Disables continue button */
  disableContinueBtn: PropTypes.bool
};

export default CartSummary;
